import { render, staticRenderFns } from "./EuVxeSortDialog.vue?vue&type=template&id=990d9000&scoped=true"
import script from "./EuVxeSortDialog.vue?vue&type=script&lang=js"
export * from "./EuVxeSortDialog.vue?vue&type=script&lang=js"
import style0 from "./EuVxeSortDialog.vue?vue&type=style&index=0&id=990d9000&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990d9000",
  null
  
)

export default component.exports